import * as React from 'react';
import Box from '@mui/joy/Box';
import Sheet from '@mui/joy/Sheet';
import Typography from '@mui/joy/Typography';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { Link as RouterLink } from 'react-router-dom';
import { AdminGeneralInfoResult } from '../../../../models/adminGeneral';
import { formatRubles } from '../../../../common/money';

export type BalanceCardProps = { data: AdminGeneralInfoResult | null };

export const BalanceCard: React.FC<BalanceCardProps> = React.memo(({ data }) => {
    return (
        <Sheet variant="outlined" sx={{ p: 2, borderRadius: '8px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <Box component={RouterLink} to={'/app/balance'} sx={{ display: 'flex', alignItems: 'center', gap: 1, textDecoration: 'none', color: 'inherit' }}>
                <MonetizationOnIcon fontSize="small" />
                <Typography level="title-md">Баланс</Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 1 }}>
                <Box>
                    <Typography level="body-sm">Баланс сайта</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1, rowGap: 0.25, flexWrap: 'wrap' }}>
                        <Typography
                            level="title-lg"
                            sx={{
                                color: (data && ((data.tomeBalance ?? 0) + (data.gameMoneyBalance ?? 0)) <= (data.siteBalance ?? 0))
                                    ? 'danger.600'
                                    : 'success.600',
                            }}
                        >
                            {data ? `${formatRubles(data.siteBalance)}` : '-'}
                        </Typography>
                    </Box>
                </Box>
                <Box>
                    <Typography level="body-sm">Баланс Tome</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1, rowGap: 0.25, flexWrap: 'wrap' }}>
                        <Typography level="title-lg">
                            {data ? `${formatRubles(data.tomeBalance)}` : '-'}
                        </Typography>
                    </Box>
                </Box>
                <Box>
                    <Typography level="body-sm">Баланс Gmoney</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1, rowGap: 0.25, flexWrap: 'wrap' }}>
                        <Typography level="title-lg">
                            {data ? `${formatRubles(data.gameMoneyBalance)}` : '-'}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Sheet>
    );
});

BalanceCard.displayName = 'BalanceCard';


